module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "vehicles"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Cliente Repom/Move Mais")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n        Identificamos que você é um cliente Repom/Move Mais!\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n        Para atendimento, favor entrar em contato nos números abaixo:\n      ")]), _vm._v(" "), _vm._m(0)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "line-height-20"
  }, [_c('b', [_vm._v("0800 701 6744")]), _vm._v(" (Telefone Fixo)"), _c('br'), _vm._v(" "), _c('b', [_vm._v("11 4166 7500")]), _vm._v(" (Telefone Celular)"), _c('br'), _vm._v("\n        Atendimento 24 horas, 7 dias da semana\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-b2542b4e!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/repom-redirect.vue
// module id = 2200
// module chunks = 1